module.exports = __webpack_public_path__ + "img/book6.8dc71f96.jpg";